import { PROVIDER_INFOS, type ProviderName } from "@cowork/shared";
import { cn } from "../../lib/utils.js";

interface Props {
  provider: ProviderName;
  model: string;
  onProviderChange: (p: ProviderName) => void;
  onModelChange: (m: string) => void;
  disabled?: boolean;
}

const PROVIDER_ORDER: ProviderName[] = ["claude", "openai", "gemini", "ollama"];

export function ModelSwitcher({
  provider,
  model,
  onProviderChange,
  onModelChange,
  disabled,
}: Props) {
  const info = PROVIDER_INFOS[provider];

  return (
    <div className="flex items-center gap-2">
      {/* Provider tabs */}
      <div className="flex rounded-lg overflow-hidden border border-[var(--border)]">
        {PROVIDER_ORDER.map((p) => (
          <button
            key={p}
            disabled={disabled}
            onClick={() => {
              onProviderChange(p);
              const first = PROVIDER_INFOS[p].models[0];
              if (first) onModelChange(first.id);
            }}
            className={cn(
              "px-3 py-1.5 text-xs font-medium transition-colors",
              "disabled:opacity-50 disabled:cursor-not-allowed",
              provider === p
                ? "bg-[var(--accent)] text-white"
                : "text-[var(--text-secondary)] hover:text-[var(--text-primary)] hover:bg-[var(--bg-tertiary)]",
            )}
          >
            {PROVIDER_INFOS[p].displayName.split(" ")[0]}
          </button>
        ))}
      </div>

      {/* Model select */}
      <select
        value={model}
        disabled={disabled}
        onChange={(e) => onModelChange(e.target.value)}
        className={cn(
          "text-xs rounded-lg border border-[var(--border)]",
          "bg-[var(--bg-secondary)] text-[var(--text-primary)]",
          "px-2 py-1.5 outline-none cursor-pointer",
          "disabled:opacity-50 disabled:cursor-not-allowed",
        )}
      >
        {info.models.map((m) => (
          <option key={m.id} value={m.id}>
            {m.displayName}
          </option>
        ))}
      </select>
    </div>
  );
}
